import {
    PAGINATION_ACTION_BEGIN,
    PAGINATION_ACTION_SUCCESS,
    PAGINATION_ACTION_FAIL
  } from '../middleware/types'
  
  const initialState = {
    SUBMIT_loading: false,
    error: {},
    response : {}
  }

  export default (state = initialState, action) => {
    switch (action.type) {
      case  PAGINATION_ACTION_BEGIN:
        return {
          ...state,
          SUBMIT_loading: true
        }
      case PAGINATION_ACTION_SUCCESS:
          return {
              ...state,
              SUBMIT_loading: false,
              response: {
                ...action.payload
              }
          }
      case PAGINATION_ACTION_FAIL:
        return {
          ...state,
          SUBMIT_loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }